export default __webpack_public_path__ + "static/media/eye-close.917c903a.svg";